import { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import { Dialog } from '@headlessui/react';

import { Button, Link } from '@/atoms';

import ExitPopUp from '@/assets/icons/ExitPopUp.svg';

import type { FunctionComponent } from 'react';
import type { TypePopUpOpenPageProps } from './types';

/**
 * PopUpOpenPage
 */
export const PopUpOpenPage: FunctionComponent<TypePopUpOpenPageProps> = ({
  className = '',
  title,
  button,
  desc,
  image,
  link,
  idPopUp,
}: TypePopUpOpenPageProps) => {
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [imageHeigth, setImageHeigth] = useState(0);
  const panel = useRef(null);

  useEffect(() => {
    const isModalShown = window.sessionStorage.getItem(idPopUp);

    if (isModalShown !== 'Shown') {
      setPopUpOpen(true);
      sessionStorage.setItem(idPopUp, 'Shown');
    } else {
      setPopUpOpen(false);
    }
  }, []);

  const togglePopUp = () => {
    setPopUpOpen(!popUpOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      const height = window.innerWidth;
      if (height < 1024) {
        setImageHeigth(200);
      } else {
        //eslint-disable-next-line
        //@ts-ignore
        setImageHeigth(panel?.current?.offsetHeight ?? 0);
      }
    };

    window.addEventListener('resize', handleResize);
    setTimeout(handleResize, 100);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Dialog
      open={popUpOpen}
      // eslint-disable-next-line
      onClose={() => {}}
      className="absolute inset-0 z-50 grid place-items-center"
    >
      <Dialog.Overlay
        className="absolute inset-0 bg-[rgba(21,33,39,0.7)]"
        onClick={togglePopUp}
      />

      <Dialog.Panel
        className={`z-50 flex h-fit w-[calc(100vw-2rem)] flex-col items-center overflow-hidden bg-[#F9F0EB] font-primary  lg:w-[900px] lg:flex-row ${className}`}
      >
        {image && (
          <div
            style={{ height: imageHeigth }}
            className="relative   !min-w-full    lg:!min-w-[450px]"
          >
            <Image layout="fill" objectFit="cover" src={image} />
            <div className="absolute right-3  top-3 z-50 flex justify-end rounded-full bg-[#F9F0EB] md:hidden">
              <ExitPopUp
                heigth={32}
                width={32}
                className=" flex-shrink-0 hover:cursor-pointer"
                onClick={togglePopUp}
              />
            </div>
          </div>
        )}
        <div
          ref={panel}
          className="flex w-full flex-col gap-8 px-5  py-3  md:gap-4  md:p-5 "
        >
          <div className="hidden justify-end md:flex">
            <ExitPopUp
              heigth={32}
              width={32}
              className=" flex-shrink-0 hover:cursor-pointer"
              onClick={togglePopUp}
            />
          </div>
          <div className="flex h-full  flex-col justify-between gap-3 md:gap-14 md:gap-6">
            <div className="flex flex-col gap-6">
              <h1 className="text-heading-mobile--h1 font-normal md:text-heading--h1">
                {title}
              </h1>
              {desc && (
                <span className="text-heading--h5 md:text-heading--h4">
                  {desc}
                </span>
              )}
            </div>
            <div className="flex flex-col justify-center gap-3">
              {button.label && (
                <Button
                  className=" w-full self-center md:!w-2/3 md:self-start"
                  size="large"
                  as="a"
                  href={button.src}
                  variant={button.variant}
                >
                  {button.label}
                </Button>
              )}
              {link.label && (
                <Link
                  arrow
                  className="flex self-center md:self-start md:pl-2"
                  variant={link.variant}
                  href={link.src ?? '#'}
                >
                  {link.label}
                </Link>
              )}
            </div>
          </div>
        </div>
      </Dialog.Panel>
    </Dialog>
  );
};

PopUpOpenPage.displayName = 'PopUpOpenPage';
